// ** Icons Import
import { Heart } from 'react-feather'
import { openInNewTab } from '@utils'
const Footer = () => {
  return (
    <p className="clearfix mb-0">
      <span className="float-md-left d-block d-md-inline-block mt-25">
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <a
          href="https://www.beuni.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          BeUni Tecnologia LTDA.
        </a>
        <span
          className="d-none d-sm-inline-block "
          style={{ paddingRight: '10px' }}
        >
          , Todos os direitos reservados.
        </span>
        <span className="d-none d-sm-inline-block">
          <a
            href="https://brands-legal-documents.s3.amazonaws.com/Termos+e+Condic%CC%A7o%CC%83es+de+Uso+-+BeUni.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Termos & Condições
          </a>
        </span>
      </span>
      {/* <span className="float-md-right d-none d-md-block">
        Feito com 🧡 pela BeUni
      </span> */}
    </p>
  )
}

export default Footer
